import React from "react";
import {
    Box,
    Card,
    Container,
    Grid,
    Stack,
    Typography,
} from "@mui/material";
import Image from "../../image";
import SetNewPasswordIntegration from "./SetNewPasswordIntegration";
import { useResponsive } from "../../../hooks/use-responsive";


function SetNewPassword() {
    const mdUp = useResponsive("up", "md");
    return (
        <>


      <Container maxWidth={false} sx={{
        backgroundColor: "#1D53E7",
       
        backgroundImage: 'url("/assets/Set_new_pass.svg")', // Replace with the actual image URL
        backgroundSize: "cover", // Adjust as needed
        backgroundPosition: "center", // Adjust as needed
        justifyContent: "center",
            alignItems: "center"
      }} >

        <Grid
          container
          sx={{
            
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {mdUp && <Grid item xs={12} md={6} lg={6}  sx={{
              // display: "flex",
              padding: { sm: "10px", md: "80px 0px", lg:" 80px 0px" },
              justifyContent: "center",
              alignItems: "center",
              minHeight: "100vh", // Full screen height
            }}  >
            <Card
              sx={{
                borderRadius: 5,
                p: { xs: 3, md: 5, lg: 5 },
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  // mt: 3,
                }}
              >
                <Image src="/assets/MegaconnectLOGO-06.svg" alt="logo" />
              </Box>
              <SetNewPasswordIntegration />
            </Card>
          </Grid>}
          {!mdUp && <Grid item xs={12} md={6} lg={6}
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              minHeight: "105vh", // Full screen height
            }} >
            <Card
              sx={{
                borderRadius: 5,
                p: { xs: 3, sm: 5, lg: 5 },
                width: "100%", // Take full width in mobile view
                // maxWidth: "400px", // Set a max-width for better appearance
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  // mt: 3,
                }}
              >
                <Image src="/assets/MegaconnectLOGO-06.svg" alt="logo" />
              </Box>
              <SetNewPasswordIntegration />
            </Card>
          </Grid>}
        </Grid>
      </Container>
    </>
    );
}

export default SetNewPassword;
